import Layout from '../../components/ui/Layout';
import { ProfileNav } from './PersonalDetails';
import { IconDeviceLaptop, IconDeviceMobile, IconDeviceTablet } from '@tabler/icons-react';

export default function ActiveSessions() {
  const sessions = [
    { device: 'MacBook Pro · Chrome', type: 'laptop', location: 'Aylesbury, UK', time: 'Active now', current: true },
    { device: 'iPhone 15 · Safari', type: 'mobile', location: 'Aylesbury, UK', time: '2 hours ago', current: false },
    { device: 'iPad · Safari', type: 'tablet', location: 'Aylesbury, UK', time: 'Yesterday', current: false },
  ];

  const DeviceIcon = ({ type }) => {
    if (type === 'mobile') return <IconDeviceMobile size={18} color="var(--color-text-secondary)" stroke={1.5} />;
    if (type === 'tablet') return <IconDeviceTablet size={18} color="var(--color-text-secondary)" stroke={1.5} />;
    return <IconDeviceLaptop size={18} color="var(--color-text-secondary)" stroke={1.5} />;
  };

  return (
    <Layout>
      <div style={{ display: 'flex', flex: 1, minHeight: '100vh' }}>
        <ProfileNav active="Active sessions" />
        <div style={{ flex: 1, padding: 'var(--main-padding)' }}>
          <h1 style={{ fontSize: 22, fontWeight: 400, marginBottom: 4 }}>Active sessions</h1>
          <p style={{ fontSize: 13, color: 'var(--color-text-tertiary)', marginBottom: 28 }}>Devices signed into your account</p>
          <div style={{ background: 'var(--color-bg-primary)', border: '0.5px solid var(--color-border-light)', borderRadius: 'var(--radius-lg)', overflow: 'hidden', marginBottom: 16 }}>
            {sessions.map((s, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '16px 20px', borderBottom: i < sessions.length - 1 ? '0.5px solid var(--color-border-light)' : 'none' }}>
                <div style={{ width: 36, height: 36, borderRadius: 'var(--radius-md)', background: 'var(--color-bg-secondary)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <DeviceIcon type={s.type} />
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3 }}>
                    <div style={{ fontSize: 13, fontWeight: 400, color: 'var(--color-text-primary)' }}>{s.device}</div>
                    {s.current && <span style={{ fontSize: 10, padding: '1px 6px', borderRadius: 20, background: 'var(--color-success-light)', color: 'var(--color-success)' }}>This device</span>}
                  </div>
                  <div style={{ fontSize: 12, color: 'var(--color-text-tertiary)' }}>{s.location} · {s.time}</div>
                </div>
                {!s.current && (
                  <button style={{ background: 'transparent', color: 'var(--color-danger)', border: '0.5px solid var(--color-danger)', borderRadius: 'var(--radius-md)', padding: '5px 12px', fontSize: 12, cursor: 'pointer' }}>
                    Revoke
                  </button>
                )}
              </div>
            ))}
          </div>
          <button style={{ background: 'transparent', color: 'var(--color-danger)', border: '0.5px solid var(--color-danger)', borderRadius: 'var(--radius-md)', padding: '9px 20px', fontSize: 13, cursor: 'pointer' }}>
            Sign out all other devices
          </button>
        </div>
      </div>
    </Layout>
  );
}
